// tslint:disable:max-line-length

import React from 'react';

export const ObjectEmbed = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="5.8,15 7.9,15 10.2,1 8.2,1" />
      <polygon points="0,9.2 4.9,12.1 4.9,9.8 1.9,8 4.9,6.2 4.9,3.9 0,6.8" />
      <polygon points="11.1,3.9 11.1,6.2 14.1,8 11.1,9.8 11.1,12.1 16,9.2 16,6.8" />
    </svg>
  );
};
